//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibAvatar',
  props: {
    avatar: {
      type: String,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    useBaseTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      if (this.useBaseTheme) {
        return this.$store.getters['theme/baseTheme'];
      }

      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.primaryColor
      };
    },
    checkStyle: function checkStyle() {
      return {
        background: this.theme.unselectedColor,
        color: this.theme.primaryColor
      };
    }
  },
  methods: {
    getRandomInt: function getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }
};